import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

import theme from '../../../theme';

const activeColor = `${theme?.components?.navigationBar?.palette?.activeColor}`;
const activeFont = `${theme?.components?.navigationBar?.typography?.active}`;
const inactiveColor = `${theme?.components?.navigationBar?.palette?.inactiveColor}`;
const inactiveFont = `${theme?.components?.navigationBar?.typography?.inactive}`;

const NavigationTab = ({ url, Icon, label, id }) => {
  const location = useLocation();
  const [active, setActive] = useState(false);
  let tabPath;
  if (url) {
    tabPath = url.startsWith('/') ? url : `/${url}`;
  }

  useEffect(() => {
    if (location.pathname === `/${url}`) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [location, url]);

  return (
    <Button
      size="medium"
      {...(tabPath ? { component: RouterLink, to: tabPath } : { onClick: () => setActive(true) })}
      startIcon={
        <SvgIcon
          sx={{
            color: active ? activeColor : inactiveColor,
          }}
        >
          <Icon />
        </SvgIcon>
      }
      sx={{
        borderRadius: '25px',
        marginLeft: '0',
        textTransform: 'capitalize',
        textDecoration: 'none',
        color: 'inherit',
      }}
      data-testid={id}
    >
      <Typography
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: active ? activeColor : inactiveColor,
          fontFamily: active ? activeFont : inactiveFont,
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};

NavigationTab.propTypes = {
  label: PropTypes.string,
  url: PropTypes.string,
  Icon: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  id: PropTypes.string,
};

export default NavigationTab;
